<h4>Summary</h4>
<div class="form-group row" [ngClass]="orderID.hasError('unique') && orderID.dirty ? 'has-warning' : ''">
    <label class="col-md-2 col-form-label">ID</label>
    <div class="col-md-10">
        <input
            data-automation-id="order-id-input"
            type="text"
            name="orderID"
            class="form-control input-medium"
            maxlength="75"
            validateUnique
            uniqueEntity="Orders"
            uniqueProperty="OrderID"
            [entityPK]="orderDetailService.order.C_Order_key"
            entityPKName="C_Order_key"
            #orderID="ngModel"
            [(ngModel)]="orderDetailService.order.OrderID"
            [disabled]="(orderDetailService.order | isNew) && orderDetailService.orderNamingActive"
            [required]="!(orderDetailService.order | isNew) || !orderDetailService.orderNamingActive"
        />
        <small class="form-text text-muted" *ngIf="orderID.errors?.unique && orderID.dirty">
            <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
            This Order ID already exists.
        </small>
        <small
            class="form-text text-muted"
            *ngIf="(orderDetailService.order | isNew) && orderDetailService.orderNamingActive"
        >
            The Order ID will be assigned automatically.
        </small>
    </div>
</div>

<div
    class="form-group row"
    *ngIf="!orderDetailService.isGLP && orderDetailService.activeFields.has(summaryField.type.name)"
>
    <label class="col-md-2 col-form-label">Type</label>
    <div class="col-md-10">
        <active-vocab-select
            [(model)]="orderDetailService.order.C_MaterialType_key"
            (modelChange)="orderDetailService.orderTypeChanged()"
            [vocabChoices]="orderDetailService.materialTypes"
            [keyFormatter]="materialTypeKeyFormatter"
            [optionFormatter]="materialTypeFormatter"
            [required]="orderDetailService.requiredFields.has(summaryField.type.fieldName)"
            [nullable]="
                !orderDetailService.requiredFields.has(summaryField.type.fieldName) ||
                orderDetailService.order.C_MaterialType_key == null
            "
        >
        </active-vocab-select>
    </div>
</div>

<div class="form-group row" *ngIf="orderDetailService.activeFields.has(summaryField.status.name)">
    <label class="col-md-2 col-form-label">Status</label>
    <div class="col-md-10">
        <active-vocab-select
            [(model)]="orderDetailService.order.C_OrderStatus_key"
            [vocabChoices]="orderDetailService.orderStatuses"
            [keyFormatter]="orderStatusKeyFormatter"
            [optionFormatter]="orderStatusFormatter"
            [defaultValue]="orderDetailService.orderStatusDefaultKey"
            [loadDefaultValue]="orderDetailService.order.C_Order_key < 0"
            [required]="orderDetailService.requiredFields.has(summaryField.status.fieldName)"
            [nullable]="
                !orderDetailService.requiredFields.has(summaryField.status.fieldName) ||
                orderDetailService.order.C_OrderStatus_key == null
            "
        >
        </active-vocab-select>
    </div>
</div>

<div class="form-group row" *ngIf="orderDetailService.activeFields.has(summaryField.orderedBy.name)">
    <label class="col-md-2 col-form-label">Ordered By</label>
    <div class="col-md-10">
        <user-select [(model)]="orderDetailService.order.OrderedBy"
                     [forceValidSelection]="false"
                     [required]="orderDetailService.requiredFields.has(summaryField.orderedBy.fieldName)">
        </user-select>
    </div>
</div>

<div class="form-group row" *ngIf="orderDetailService.activeFields.has(summaryField.animalSampleOrigin.name)">
    <label class="col-md-2 col-form-label">Animal/Sample Origin</label>
    <div class="col-md-10">
        <active-vocab-select
            [(model)]="orderDetailService.order.C_MaterialOrigin_key"
            [vocabChoices]="orderDetailService.materialOrigins"
            [keyFormatter]="materialOriginKeyFormatter"
            [optionFormatter]="materialOriginFormatter"
            [defaultValue]="orderDetailService.materialOriginDefaultKey"
            [loadDefaultValue]="orderDetailService.order.C_Order_key < 0"
            [required]="orderDetailService.requiredFields.has(summaryField.animalSampleOrigin.fieldName)"
            [nullable]="
                !orderDetailService.requiredFields.has(summaryField.animalSampleOrigin.fieldName) ||
                orderDetailService.order.C_MaterialOrigin_key == null
            "
        >
        </active-vocab-select>
    </div>
</div>

<order-institution-table
    *ngIf="orderDetailService.activeFields.has(summaryField.institutions.name)"
    class="institutions-table"
    [order]="orderDetailService.order"
    [readonly]="orderDetailService.readonly || orderDetailService.order.IsLocked"
    [required]="orderDetailService.requiredFields.has(summaryField.institutions.fieldName)"
    [siteRequired]="
        orderDetailService.requiredFields.has(summaryField.institutionSite.fieldName) &&
        orderDetailService.hasInstitutionsWithoutSite
    "
    [siteVisible]="orderDetailService.activeFields.has(summaryField.institutionSite.name)"
>
</order-institution-table>
